import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import WhatsAppIcon from "./WhatsAppIcon";

export default function WhatsAppFloating() {
  const [phone, setPhone] = useState("919890201047");
  useEffect(() => {
    api.get("/company").then(r => {
      const n = (r.data.phone || "").replace(/\D/g,'');
      if (n) setPhone(n);
    }).catch(()=>{});
  }, []);
  const msg = encodeURIComponent("Hi Shruti Tours, I'd like to book a ride.");
  return (
    <a
      href={`https://wa.me/${phone}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="wa-pulse fixed bottom-5 left-5 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#22c55e] grid place-items-center shadow-2xl shadow-emerald-500/40 transition-transform hover:-translate-y-0.5"
      aria-label="WhatsApp us"
    >
      <WhatsAppIcon className="w-7 h-7 text-white" />
    </a>
  );
}
